<template>
  <section class="inventory--part-details animated fadeIn">
    <div class="list-group-item mb-2">
      <div class="input-group">
        <b-form-radio-group
          :options="['Yes', 'No', 'N/A']"
          v-model="model.leadVerification_ObtainCopyMfrDatasheet"
        >
          <span class="col-form-label">Can you obtain a copy of the MFR datasheet? If No, please explain here</span>
        </b-form-radio-group>
        <b-form-input type="text" class="col-4 ml-2" v-model="model.leadVerification_ObtainCopyMfrDatasheetReason"></b-form-input>  
      </div>

      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.leadVerification_StraightLeads"
      >
        <span class="col-form-label">Do the leads appear to be straight and properly aligned?</span>
      </b-form-radio-group>

      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.leadVerification_PinCountVerified"
      >
        <span class="col-form-label">Did you verify the pin count and confirm that the number of pins on device is same as listed on MFR datasheet?</span>
      </b-form-radio-group>

      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.leadVerification_LeadsImproperHandlingSignsFree"
      >
        <span class="col-form-label">Do the leads appear to be free of any signs of improper handling?</span>
      </b-form-radio-group>

      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.leadVerification_UsedLeads"
      >
        <span class="col-form-label">Do the leads show any signs of use?</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.leadVerification_DirtyLeads"
      >
        <span class="col-form-label">Do the leads show any sign of dirt and dust?</span>
      </b-form-radio-group>
      <b-form-radio-group
        :options="['Yes', 'No', 'N/A']"
        v-model="model.leadVerification_PinDamage"
      >
        <span class="col-form-label">Do you see any broken, missing, bent or damaged leads?</span>
      </b-form-radio-group>
      <div class="input-group">
        <b-form-radio-group
          :options="['Yes', 'No', 'N/A']"
          v-model="model.leadVerification_VisibleSolder"
        >
          <span
            class="col-form-label"
          >Do you see any signs of solder residue, solder burns, re-tinning or detect inconsistent coloration? Please note your observations here</span>
        </b-form-radio-group>  
        <b-form-input type="text" class="col-3 ml-2" v-model="model.leadVerification_VisibleSolderObservation"></b-form-input>  
      </div>
      
      <div class="input-group">
        <b-form-input type="text" class="col-1 mr-2"  v-model="model.leadVerification_NumberNonConform"></b-form-input>
        <b-form-group>
          <span class="col-form-label">No. of non-conformities</span>
        </b-form-group>
      </div>
      
      <b-form-radio-group :options="['Yes', 'No', 'N/A']" v-model="model.leadVerification_PhotosTaken">
        <span class="col-form-label">Were digital photos taken of the part?</span>
      </b-form-radio-group>

      <b-form-group label="Lead Notes">
        <b-textarea type="text" v-model="model.leadVerification_Notes"></b-textarea>
      </b-form-group>

      <!--<b-form-group label-cols-sm="1" label="Physical Package Type">
        <b-form-input type="text" class="col-3" v-model="model.leadVerification_PhysicalPackage"></b-form-input>
      </b-form-group>-->
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import {FIELDS}  from '../../constants'
export default {
  name: 'aegisLead',
  components: {},
  props: {
    inspectionDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        leadVerification_StraightLeads: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__STRAIGHT_LEADS] || '',
        leadVerification_UsedLeads: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__USED_LEADS] || '',
        leadVerification_DirtyLeads: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__DIRTY_LEADS] || '',
        leadVerification_PinDamage: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__PIN_DAMAGE] || '',
        leadVerification_VisibleSolder: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__VISIBLE_SOLDER] || '',
        leadVerification_PhysicalPackage: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__PHYSICAL_PACKAGE] || '',
        leadVerification_ObtainCopyMfrDatasheet: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__OBTAIN_COPY_MFR_DATASHEET] || '',
        leadVerification_ObtainCopyMfrDatasheetReason: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__OBTAIN_COPY_MFR_DATASHEET_REASON] || '',
        leadVerification_PinCountVerified: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__PIN_COUNT_VERIFIED] || '',
        leadVerification_LeadsImproperHandlingSignsFree: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__LEADS_IMPROPER_HANDLING_SIGNS_FREE] || '',
        leadVerification_PhotosTaken: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__PHOTOS_TAKEN] || '',
        leadVerification_NumberNonConform: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__NUMBER_NON_CONFORM] || '',
        leadVerification_VisibleSolderObservation: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__VISIBLE_SOLDER_OBSERVATION] || '',
        leadVerification_Notes: this.inspectionDetails[FIELDS.LEAD_VERIFICATION__NOTES] || '',
      },
    };
  },
  computed: {},
  mounted() {},
};
</script>